import { render, staticRenderFns } from "./mix-grid-tile.vue?vue&type=template&id=2808f706&"
import script from "./mix-grid-tile.vue?vue&type=script&lang=js&"
export * from "./mix-grid-tile.vue?vue&type=script&lang=js&"
import style0 from "./mix-grid-tile.vue?vue&type=style&index=0&id=2808f706&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports